module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-italic.51521a2.woff2";